module.exports = __webpack_public_path__ + "img/backToGame.ec3fda1a.png";